function resolveDisplayLocale(language) {
    if (!language) return 'en-US';
    if (language.startsWith('es')) return 'es';
    return 'en-US';
}

export function formatDisplayDate(value, language) {
    if (!value) return '—';
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return new Intl.DateTimeFormat(resolveDisplayLocale(language), {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        }).format(value);
    }
    const iso = String(value).trim().slice(0, 10);
    const parts = iso.split('-');
    if (parts.length !== 3) return String(value);
    const [year, month, day] = parts.map((part) => parseInt(part, 10));
    if (!year || !month || !day) return iso;
    const date = new Date(year, month - 1, day);
    if (Number.isNaN(date.getTime())) return iso;
    return new Intl.DateTimeFormat(resolveDisplayLocale(language), {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
    }).format(date);
}

/** Format ISO date strings for display; pass through other text unchanged. */
export function formatDisplayDateValue(value, language) {
    if (value == null || value === '') return '—';
    const text = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        return formatDisplayDate(text, language);
    }
    return text;
}
